import React from 'react';
import ServicePageSplit from '../ServicePageSplit/ServicePageSplit';
import sectionImage from '../../assets/services/complete-yard-care.jpg';

const tags = [
  'Mowing',
  'Tree trimming',
  'Spring cleanup',
  'Weed control',
  'Fertilizer',
  'Aeration',
  'Dethatching',
  'Fall cleanup',
  'Shrub trimming',
  'Trimming and edging',
  'Gutter cleaning',
  'Irrigation startup',
];

const paragraphs = [
  'Our maintenance team shows up on schedule, every time. You get the same crew who knows your property — gates, irrigation quirks, and the spots that need extra attention.',
  'We build a plan around what your yard actually needs: mowing and edging, seasonal cleanups, fertilization, trimming, and the details that keep everything looking intentional instead of barely managed.',
  "Colorado's seasons ask a lot of outdoor spaces. We handle irrigation startup and winterization, aeration, dethatching, and fall prep so your lawn and beds stay healthy from spring snowmelt through dry summer heat.",
];

const ServiceYardCareIntro = () => (
  <ServicePageSplit
    variant="white"
    tag="WHAT WE DO"
    heading="We handle everything,"
    headingAccent=" so you don't have to."
    paragraphs={paragraphs}
    image={sectionImage}
    imageAlt="Complete yard care maintenance by Fresh Start"
    tags={tags}
  />
);

export default ServiceYardCareIntro;
